import script from "./AddTeamTaxModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeamTaxModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTeamTaxModal.vue?vue&type=style&index=0&id=699ca17c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699ca17c"]])

export default __exports__